import { create } from 'zustand';

/**
 * Open/close state for the ⌘K command palette.
 *
 * The pre-PR-#34 store also tracked a `mode: 'default' | 'add-to-watchlist'`
 * axis used to rewire the entity-row select callback. The current
 * palette (sectioned Go to / Ask / Run action) infers routing from
 * query text + section, with no need for an external mode flag, so
 * `mode` / `openWithMode` / `toggle` were dropped on cleanup.
 *
 * If a future surface needs a select-callback override (e.g. a
 * picker palette opened from a dossier), introduce a typed callback
 * registration rather than reviving a global mode axis.
 */
interface CommandPaletteState {
  open: boolean;
  setOpen: (v: boolean) => void;
  close: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  close: () => set({ open: false }),
}));
